import { Component, OnInit, Input} from '@angular/core';
import { FormBlock, FormDocBuilder } from '../../../core/models/physician/form-doc-builder';

@Component({
  selector: 'app-form-document-builder',
  templateUrl: './form-document-builder.component.html',
  styleUrls: ['./form-document-builder.component.scss']
})
export class FormDocumentBuilderComponent implements OnInit {
  @Input() formBuilder: FormDocBuilder;
  @Input() formId: number;
  constructor() { }

  ngOnInit() {

  }
  setDefaultValues() {
    if (!this.formBuilder) {
      this.formBuilder = new FormDocBuilder();
    }

    if (!this.formBuilder.blocks) {
      this.formBuilder.blocks = [];
    }
  }

  addBlock(ind: number) {
    var self = this;
   
      var block: FormBlock = {
        blockId: self.getNextBlockId(),
        sectionTitle: '',
        items: []
      };

    self.formBuilder.blocks.splice(ind ? ind : 0, 0, block);

      console.log('formAfterBlock', self.formBuilder);
  }

  removeBlock(ind: number) {
    this.formBuilder.blocks.splice(ind, 1);
  }

  getNextBlockId(): string {
    var self = this;
    //console.log('item' + ind, blockItem);
    if (self.formBuilder && self.formBuilder.blocks) {
      var blockId = 'b' + self.formBuilder.blocks.length.toString();
      if (!(self.formBuilder.blocks.filter(i => i.blockId == blockId).length > 0)) {
        return blockId;
      } else {
        let counter = 1;
        while (self.formBuilder.blocks.filter(i => i.blockId == ('b' + counter)).length > 0) {
          counter++;
        }
        return 'b' + counter;
      }
    } else
      return 'b0';
  }
}
